"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    n = require("@react-pdf-viewer/core");

function t(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  return e && Object.keys(e).forEach(function (t) {
    if ("default" !== t) {
      var r = Object.getOwnPropertyDescriptor(e, t);
      Object.defineProperty(n, t, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[t];
        }
      });
    }
  }), n.default = e, Object.freeze(n);
}

var r = t(e),
    o = function o() {
  return r.createElement(n.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M4.5,8.5H14\n                M4.5,11.5h6\n                M4.5,5.5h7\n                M4.5,14.5h4\n                M4.5,17.5h4\n                M10.5,23.5h-9c-0.552,0-1-0.448-1-1v-21\n                c0-0.552,0.448-1,1-1h13.293c0.265,0,0.52,0.105,0.707,0.293L19.207,4.5C19.395,4.687,19.5,4.942,19.5,5.207V8.5\n                M17.5,11.5\n                c3.314,0,6,2.686,6,6s-2.686,6-6,6s-6-2.686-6-6S14.186,11.5,17.5,11.5z\n                M17.5,20.5v-6\n                M17.5,14.5l-2.25,2.25\n                M17.5,14.5l2.25,2.25"
  }));
},
    _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var n, t = 1, r = arguments.length; t < r; t++) {
      for (var o in n = arguments[t]) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    l = {
  left: 0,
  top: 8
},
    c = function c(e) {
  var t = e.onClick,
      i = r.useContext(n.LocalizationContext),
      c = i && i.open ? i.open.openFile : "Open file";
  return r.createElement(n.Tooltip, {
    position: n.Position.BottomCenter,
    target: r.createElement("div", {
      className: "rpv-open-button"
    }, r.createElement("input", {
      className: "rpv-open-input",
      multiple: !1,
      type: "file",
      title: "",
      onChange: t
    }), r.createElement(o, null)),
    content: function content() {
      return c;
    },
    offset: l
  });
},
    u = function u(e) {
  var n = e.store;
  return (e.children || function (e) {
    return r.createElement(c, {
      onClick: e.onClick
    });
  })({
    onClick: function onClick(e) {
      console.log("Open file");
      var t = e.target.files;

      if (t && t.length) {
        var r = n.get("openFile");
        r && r(t[0]);
      }
    }
  });
},
    a = function a(e) {
  var t = e.onClick,
      i = r.useContext(n.LocalizationContext),
      l = i && i.open ? i.open.openFile : "Open file";
  return r.createElement(n.MenuItem, {
    icon: r.createElement(o, null),
    onClick: function onClick() {}
  }, r.createElement("div", {
    className: "rpv-open-menu-item"
  }, r.createElement("input", {
    className: "rpv-open-input",
    multiple: !1,
    type: "file",
    title: "",
    onChange: t
  }), l));
};

exports.OpenFileIcon = o, exports.openPlugin = function () {
  var e = r.useMemo(function () {
    return n.createStore({});
  }, []),
      t = function t(n) {
    return r.createElement(u, _i({}, n, {
      store: e
    }));
  };

  return {
    install: function install(n) {
      e.update("openFile", n.openFile);
    },
    Open: t,
    OpenButton: function OpenButton() {
      return r.createElement(t, null);
    },
    OpenMenuItem: function OpenMenuItem() {
      return r.createElement(t, null, function (e) {
        return r.createElement(a, {
          onClick: e.onClick
        });
      });
    }
  };
};